.dotLoader {
  position: relative;
  padding: 20px 0;
  display: flex;
  justify-content: center;

  &.fullScreen {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
